import PropTypes from 'prop-types';
import React from 'react';

import './SearchSelect.scss';

/**
 * Select widget for searching for jobs
 * @todo refactor to be a generic select widget
 */
export default class SearchSelect extends React.Component {
    static propTypes = {
        /**
         * icon name
         */
        icon: PropTypes.oneOf([null, 'location', 'star', 'search', 'wing']),
        /**
         * name of search select field
         */
        name: PropTypes.string,
        /**
         * default value for the select options
         */
        value: PropTypes.PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        /**
         * function to be invoked on selecting
         */
        onChange: PropTypes.func,
        /**
         * options for select menu
         */
        options: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                value: PropTypes.PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number,
                ]),
            })
        ),
        /**
         * value for qa data attribute
         */
        qaDataAttr: PropTypes.string,
    };

    static defaultProps = {
        icon: null,
        name: '',
        value: null,
        options: [],
    };

    onSelect = (e) => {
        this.props.onChange(e.target.value);
    };

    render() {
        let inputClassName = 'formControl';
        if (this.props.icon) {
            inputClassName += ' hasIcon ' + this.props.icon + 'Icon';
        }

        return (
            <div className="components-Input-SearchSelect">
                <select
                    data-qa={this.props.qaDataAttr}
                    className={inputClassName}
                    name={this.props.name}
                    defaultValue={this.props.value}
                    onChange={this.onSelect}
                >
                    {this.props.options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.name}
                        </option>
                    ))}
                </select>
                <div className="selectArrowIcon" />
            </div>
        );
    }
}
